var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6L.757 1.757 2.172.343 5 3.172 7.828.343l1.415 1.414L5 6z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/svg/chevron-down.svg";
export { SvgChevronDown as ReactComponent };